<template>
  <b-modal id="createBulkLicenseModal" ref="createBulkLicenseModal" @close="resetModal">
    <template slot="modal-title">{{ $t('bulkLicenseCreation') }}</template>
    <b-form>
      <fieldset :disabled="createLoading">
        <b-form-group id="licenseModel-group" :label="$t('licenseModel')" label-for="licenseModel">
          <b-form-select id="licenseModel" v-model="licenseModel" :options="licenseModels" autofocus/>
        </b-form-group>

        <b-form-group id="channel-group" :label="$t('channel')" label-for="channel">
          <b-form-select
            id="channel"
            v-model="channel"
            :options="channelOptions"
          >
            <template slot="first">
              <option :value="null">{{ $t('none')}}</option>
            </template>
          </b-form-select>
        </b-form-group>

        <details-form :fields="bulkParametersFields()" :state-object="bulkParameters"/>
      </fieldset>
    </b-form>

    <div slot="modal-footer" class="col-md-12">
      <b-form>
        <fieldset :disabled="createLoading">
          <b-button variant="primary" class="float-lg-right" @click="createBulkLicense" :disabled="validate">{{ $t('create') }}</b-button>
          <b-button variant="secondary" class="float-lg-left" @click="resetModal">{{ $t('cancel') }}</b-button>
        </fieldset>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
  import DetailsForm from '../../components/DetailsForm'
  import { mapGetters } from 'vuex'
  import LicenseService from '../../services/LicenseService'

  export default {
    name: 'CreateBulkLicense',
    data () {
      return {
        licenseModel: 'SCHOOL',
        channel: null,
        createLoading: false
      }
    },
    components: {
      DetailsForm
    },
    computed: {
      ...mapGetters('licenses', ['bulkParameters']),
      validate () {
        if(this.licenseModel === 'INDIVIDUAL') {
          return !(this.bulkParameters.organizationNumbers && this.bulkParameters.eans
            && this.bulkParameters.usageRights && this.bulkParameters.description
            && this.bulkParameters.validFrom && this.bulkParameters.validTo)
        }
        if(this.licenseModel === 'SCHOOL') {
          return !(this.bulkParameters.organizationNumbers && this.bulkParameters.eans && this.bulkParameters.description
            && this.bulkParameters.validFrom && this.bulkParameters.validTo)
        }
        return true
      },
      licenseModels () {
        return [
          { value: 'SCHOOL', text: this.$t('licenseModels.SCHOOL') },
          { value: 'INDIVIDUAL', text: this.$t('licenseModels.INDIVIDUAL') }
        ]
      },
      channelOptions() {
        return ['SKOLON', 'AVT']
      },
    },
    methods: {
      bulkParametersFields () {
        return [
          { type: 'textarea', width: 12, name: 'organizationNumbers', displayName: this.$t('organizationNumbers'), required: true, autofocus:true },
          { type: 'textarea', width: 12, name: 'eans', displayName: this.$t('eans'), required: true },
          { type: this.licenseModel === 'INDIVIDUAL' ? 'number' : 'hidden', width: 12, name: 'usageRights', required: this.licenseModel === 'INDIVIDUAL' },
          { type: 'text', width: 12, name: 'description', displayName: this.$t('description'), required: true },
          { type: 'date', width: 12, name: 'validFrom', required: true },
          { type: 'date', width: 12, name: 'validTo', required: true }
        ]
      },
      createBulkLicense () {
        this.createLoading = true
        let organizationNumbers = this.bulkParameters.organizationNumbers?.split(/[\s,]+/).filter(e => e != null && e !== '')
        let eans = this.bulkParameters.eans?.split(/[\s,]+/).filter(e => e != null && e !== '')
        let license = {
          licenseModel: this.licenseModel,
          channel: this.channel,
          ownership: 'ORGANIZATION',
          description: this.bulkParameters.description,
          validFrom: this.bulkParameters.validFrom,
          validTo: this.bulkParameters.validTo,
          usageRights: this.bulkParameters.usageRights
        }
        let me = this
        LicenseService.bulkCreateLicenses(organizationNumbers, eans, license)
          .then(() => {
            me.$bvModal.hide('createBulkLicenseModal')
            this.showSuccessToast()
          }).finally(() => {
            this.createLoading = false
          })
      },
      showSuccessToast () {
        this.$bvToast.toast(this.$t('licenseCreatedSuccess'),{
          title: this.$t('success'),
          toaster: 'b-toaster-top-center',
          variant: 'success',
          autoHideDelay: 10000
        })
      },
      resetModal () {
        this.$store.dispatch('licenses/resetBulkParameters')
        this.$refs['createBulkLicenseModal'].hide()
      }
    }
  }

</script>